// extracted by css-extract-rspack-plugin
export default {"floatingButtonSpace":"FloatingButton__floatingButtonSpace--TA5S7"};